import React from 'react'
import Form from '../../../form'
import Quote from '../../../quote'

interface IText {
  header: string
  description: string
}

export const BarberShop: React.FC = () => {
  const texts = getText()
  return (
    <>
      <div className='onlinepbx__container'>

        <div className='onlinepbx__story'>
          <div className='onlinepbx__story__block__row onlinepbx__story__block__row__head onlinepbx__story__block__row__bottom'>
            <div className='onlinepbx__story__left onlinepbx__story__description'>
              <h2>
                Телефония для роста выручки барбершопов
              </h2>
              <div className='onlinepbx__story__text onlinepbx__story__text__head'>
                <div className='onlinepbx__story__text__paragraph'>
                  Любая необработанная заявка&nbsp;&mdash; это упущенный клиент и&nbsp;впустую потраченные деньги на&nbsp;рекламу.
              </div>
                <div className='onlinepbx__story__text__paragraph'>
                  Если сократить количество пропущенных вызовов и&nbsp;автоматически формировать базу клиентов&nbsp;&mdash; можно легко увеличить поток заказов при том&nbsp;же рекламном бюджете.
              </div>
              </div>
              <div>
                <Form text='Попробовать onlinepbx' pageName='Истории' />
              </div>
            </div>
            <div className='onlinepbx__story__right onlinepbx__story__image'>
              <img src={process.env.PUBLIC_DIR + '/images/stories/story2-big.png'} />
            </div>
          </div>

          <div className='onlinepbx__story__block onlinepbx__story2__block1'>
            <h2 className='onlinepbx__content__header__center'>
              Как у&nbsp;барбершопа теряются клиенты
            </h2>
            <div className='onlinepbx__story__block__row onlinepbx__story__block__row__block1 onlinepbx__story__block__row__center'>
              <div className='onlinepbx__story__left onlinepbx__story__image'>
                <img src={process.env.PUBLIC_DIR + '/images/stories/story2-block1.svg'} className='onlinepbx__story__block__svg' />
              </div>
              <div>
                <div className='onlinepbx__story__block__header'>
                  Пропущенные вызовы не&nbsp;обрабатываются
                </div>
                <div className='onlinepbx__story__text'>
                  <div className='onlinepbx__story__text__paragraph'>
                    Например, барбершопу, в&nbsp;котором работают четыре мастера и&nbsp;один администратор, в&nbsp;среднем звонят 19&nbsp;клиентов в&nbsp;день. Из-за того, что сотрудники не&nbsp;перезванивают по&nbsp;пропущенным вызовам, барбершоп теряет 8&nbsp;клиентов, которые не&nbsp;смогли записаться на&nbsp;услугу.
                  </div>
                  <div className='onlinepbx__story__text__paragraph'>
                    До&nbsp;начала рабочего дня количество пропущенных составляет&nbsp;9%, в&nbsp;обеденное время&nbsp;&mdash; 7%, а&nbsp;после закрытия&nbsp;&mdash; процент пропущенных достигает уже 100%.
                </div>
                </div>
              </div>
            </div>
          </div>

          <div className='onlinepbx__story__block onlinepbx__story2__block2'>
            <div className='onlinepbx__story__block__header onlinepbx__story__block__header__center'>
              Процент пропущенных вызовов за&nbsp;день
          </div>
            <div className='onlinepbx__story__graph__container'>
              <img src={process.env.PUBLIC_DIR + '/images/stories/story2-block2.svg'} className='onlinepbx__story__graph' />
            </div>
            <div className='onlinepbx__story__block__center onlinepbx__story__block__quote'>
              <Quote
                outside
                className='onlinepbx__story__block__thumb__container'
                width='803'
                icon={<img src={process.env.PUBLIC_DIR + '/images/stories/thumbs-down.svg'} className='onlinepbx__story__block__thumb__icon' />}>
                  <div>При конверсии в 50% и стоимости стрижки в 1000 рублей, из-за пропущенных звонков теряется 3000-4000 рублей в день. В среднем восемь клиентов не доходят до салона.</div>
                </Quote>
            </div>
          </div>

          <div className='onlinepbx__story__block onlinepbx__story__block3'>
            <div className='onlinepbx__story__block__row onlinepbx__story__block__row__center'>
              <div className='onlinepbx__story__left onlinepbx__story__description'>
                <div className='onlinepbx__story__block__header'>
                  База клиентов не&nbsp;формируется автоматически
                </div>
                <div className='onlinepbx__story__text'>
                  Все звонки с&nbsp;клиентами терялись и&nbsp;менеджер не&nbsp;знал, какой клиент звонит: новый или постоянный. Он&nbsp;не&nbsp;мог предложить персональную скидку или сразу записать к&nbsp;мастеру, у&nbsp;которого клиент стригся месяц назад.
              </div>
              </div>
              <div className='onlinepbx__story__right onlinepbx__story__image'>
                <img src={process.env.PUBLIC_DIR + '/images/stories/story2-block3.svg'} className='onlinepbx__story__block__svg' />
              </div>
            </div>
          </div>

          <div className='onlinepbx__story__block onlinepbx__story__block4'>
            <h2 className='onlinepbx__content__header__center'>
              Как вернуть клиентов
            </h2>
            <div className='onlinepbx__story__block__item__container'>
              <div className='onlinepbx__story__text onlinepbx__story__block__item'>
                <span className='onlinepbx__story__text__index'>
                  1.
                </span>
                Сократить количество пропущенных вызовов, чтобы не&nbsp;терять клиентов.
              </div>
              <div className='onlinepbx__story__text onlinepbx__story__block__item'>
                <span className='onlinepbx__story__text__index'>
                  2.
                </span>
                Автоматически формировать базу клиентов&nbsp;&mdash; так можно рассказывать клиентам о&nbsp;скидках и&nbsp;увеличивать повторные продажи.
              </div>
            </div>
          </div>

          <div className='onlinepbx__story__block onlinepbx__story__block5'>
            <h2 className='onlinepbx__content__header__center'>
              {`Для решения этих задач использовали \n два инструмента — CRM и телефонию`}
            </h2>
            <div className='onlinepbx__story__block__item__list__container'>
              <div className='onlinepbx__story__block__item__list'>
                <div className='onlinepbx__story__block__item__header'>
                  Интегрировали CRM
                </div>
                <div className='onlinepbx__story__text'>
                  Теперь при каждом звонке создавалась карточка клиента с&nbsp;контактной информацией и&nbsp;база формировалась автоматически
                </div>
              </div>
              <div className='onlinepbx__story__block__item__list'>
                <div className='onlinepbx__story__block__item__header'>
                  Подключили телефонию
                </div>
                <div className='onlinepbx__story__text'>
                  <div className='onlinepbx__story__text__paragraph'>
                    Настроили уведомления о&nbsp;пропущенных.
                  </div>
                  <div className='onlinepbx__story__text__paragraph'>
                    Подключили автоответчик в&nbsp;нерабочее время с&nbsp;сообщением о&nbsp;времени работы, чтобы клиент знал, когда можно перезвонить.
                  </div>
                  <div className='onlinepbx__story__text__paragraph'>
                    Настроили отчеты, чтобы отслеживать статистику по&nbsp;звонкам.
                  </div>
                </div>
              </div>
            </div>
            <div className='onlinepbx__story__block__center onlinepbx__story__block__quote'>
              <Quote
                outside
                className='onlinepbx__story__block__thumb__container'
                width='803'
                icon={<img src={process.env.PUBLIC_DIR + '/images/stories/thumbs-up.svg'} className='onlinepbx__story__block__thumb__icon' />}>
                  <div>В результате получилось настроить входящие вызовы так, что все пропущенные вызовы обрабатываются, клиентская база растет, и записей на услугу с рекламы стало в полтора раза больше.</div>
                </Quote>
            </div>
          </div>

          <div className='onlinepbx__story__block onlinepbx__story2__block4'>
            <h2 className='onlinepbx__content__header__center'>
              Что
              <span className='onlinepbx__content__header__green'> online</span>
              <span className='onlinepbx__content__header__black'>pbx</span>{' '}
              делает для барбершопа
            </h2>
            <div className='onlinepbx__story__block__list'>
              {texts.map((text, index) => {
                return (
                  <div className='onlinepbx__story__block__list__item'>
                    <div className='onlinepbx__story__block__item__header'>{`${index + 1}. ${text.header}`}</div>
                    <div className='onlinepbx__story__text' >{text.description}</div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>

      </div>

      <div className='onlinepbx__story__block__form__wrapper'>
        <h2 className='onlinepbx__content__header__center'>
          Настроим сервис <span className='onlinepbx__content__header__green'>бесплатно</span> за 30 минут!
        </h2>
        <div className='onlinepbx__story__block__form'>
          <Form free isWhite text='Подключить бесплатно' pageName='Истории' />
        </div>
      </div>
    </>
  )
}

const getText = (): IText[] => {
  return [{
    header: 'Пропущенные звонки фиксируются',
    description: 'Телефония фиксирует все пропущенные звонки и менеджеры будут вовремя перезванивать клиентам. Вы сможете анализировать причины пропущенных звонков и уменьшать их количество.'
  }, {
    header: 'Номера клиентов не теряются',
    description: 'Администратору не придется вручную записывать номер телефона клиента.'
  }, {
    header: 'Логика входящих звонков легко настраивается',
    description: 'Например, — на кого направится звонок, если трубку не подняли спустя 10 секунд, или кому направится звонок, если позвонили в нерабочее время.'
  }, {
    header: 'Голосовое меню помогает вести клиента к цели',
    description: 'Вы можете настроить голосовое приветствие и направить клиента по голосовому меню к нужному сотруднику.'
  }, {
    header: 'АТС записывает и хранит каждый разговор',
    description: 'За дополнительную плату вы можете подключить модуль “Запись разговоров”. Записанные разговоры будут доступны для скачивания и прослушки в течение года. Прослушка звонков позволит оценить качество обслуживания (соответствие скрипту, вежливость, наличие слов-паразитов).'
  }, {
    header: 'Работает коллтрекинг для эффективной рекламы',
    description: 'Легко отслеживать эффективность каждой рекламной активности, если к номеру телефона подключить коллтрекинг — код, который устанавливается на сайт и подменяет телефонные номера, в зависимости от того, откуда пришел посетитель: с Яндекс.Директа или баннера в центре города.'
  }]
}

export default BarberShop
